import { Trip } from "../../DataStructures/Trip/Trip";
import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { VehicleService } from "../../services/vehicle-service/vehicle.service";
import { Injectable } from "@angular/core";
import { VehicleType } from "../../DataStructures/Vehicle/VehicleType";
import { Suggestion } from "./Suggestion";
import { TypeRatio } from "./TypeRatio";
import { VehicleRatio } from "./VehicleRatio";
import { VehicleReservation } from "../../DataStructures/VehicleReservation/VehicleReservation";
import { TripHelper } from "../TripHelper/TripHelper";
import { RunConfig } from "../../DataStructures/RunConfiguration/RunConfig";

export class VehicleSuggestion {


    vehicleTypes = new Array<VehicleType>();
    trips: Array<Trip>;

    constructor(private vehicleService: VehicleService, private runConfig: RunConfig) {
    
    }


    /** GET THE BEST FIT VEHICLE GIVEN A LIST OF VEHICLES*/
    public static getBestFitVehicle(trip: Trip, vehicles: Array<Vehicle>): Vehicle {

        
        var bestVehicle = null;
        for (var i = 0; i < vehicles.length; i++) {

            var vehicle = vehicles[i];
            var ratio = vehicle.capacity / trip.passengers.length;

            if (ratio >= 1) {
                //Vehicle can hold
                if (bestVehicle == null) {
                    bestVehicle = new VehicleRatio(vehicle, ratio, trip);
                } else if (ratio < bestVehicle.ratio) {
                    bestVehicle = new VehicleRatio(vehicle, ratio, trip);
                }
            }
        }
        return bestVehicle != null ? bestVehicle.vehicle : null;
    }


    private static getBestFitVehicleRatio(trip: Trip, vehicles: Array<Vehicle>): VehicleRatio {

        var bestVehicle: VehicleRatio = null;
        for (var i = 0; i < vehicles.length; i++) {

            var vehicle = vehicles[i];
            var ratio = vehicle.capacity / trip.areas.length;

            if (ratio >= 1) {
                //Vehicle can hold
                if (bestVehicle == null) {
                    bestVehicle = new VehicleRatio(vehicle, ratio, trip);
                } else if (ratio < bestVehicle.ratio) {

                    if (vehicle.contracted == 1) {
                        
                        if (bestVehicle.vehicle.contracted == 1) {

                            bestVehicle = new VehicleRatio(vehicle, ratio, trip);
                        }

                    } else if (vehicle.contracted == 0) {

                        if (bestVehicle.vehicle.contracted == 0) {
 
                            bestVehicle = new VehicleRatio(vehicle, ratio, trip);
                        }
                    }

                } else if (ratio >= bestVehicle.ratio && vehicle.contracted == 0 && bestVehicle.vehicle.contracted == 1) {

                    bestVehicle = new VehicleRatio(vehicle, ratio, trip);
                }
            }
        }
        if (bestVehicle == null) {
            return new VehicleRatio(null, null, trip);
        } else {
            return bestVehicle;
        }
    }

    //Recursion end when all conflicts have been resolved
    public static getBestFitVehicles(trips: Array<Trip>, vehicles: Array<Vehicle>): Array<VehicleRatio> {

        var ratios = new Array<VehicleRatio>();
        var conflictingRatios = new Array<VehicleRatio>();


        trips.forEach(t => {
            var ratio = this.getBestFitVehicleRatio(t, vehicles);
            ratios.push(ratio);
        });

        //Resolve Conflicts
        vehicles.forEach(v => {

            var ratiosForVehicle = new Array<VehicleRatio>();

            ratiosForVehicle = ratios.filter(vr => vr.vehicle == v);
            if (ratiosForVehicle.length > 1) {
                
                var lowest = this.getLowestRatio(ratiosForVehicle);
                ratiosForVehicle.forEach(r => {
                    if (r != lowest) {
                        r.vehicle = null;
                        r.ratio = null;
                        conflictingRatios.push(ratios.splice(ratios.indexOf(r), 1)[0]);
                    }
                })
            }
        });

        if (conflictingRatios.length > 0) {

            //Remove Conflicting Trips From Ratios And Push It In Conflicting Trips Array
            var tripsWithConflicts = new Array<Trip>();
            conflictingRatios.forEach(c => {
                tripsWithConflicts.push(c.trip);
            });

            var vehiclesToPass = vehicles.filter(v => ratios.find(r => r.vehicle == v) == null)
            return ratios.concat(this.getBestFitVehicles(tripsWithConflicts, vehiclesToPass));
        }

        return ratios;

    }

    private static getLowestRatio(ratios: Array<VehicleRatio>) {

        var lowest: VehicleRatio = null;
        ratios.forEach(r => {

            if (lowest == null) {
                lowest = r;
            } else if (lowest.ratio > r.ratio) {
                lowest = r;
            }
        })

        return lowest;
    }

    getSuggestions(trips: Array<Trip>): Promise<Array<Suggestion>> {
        
        this.trips = trips;

        return new Promise((resolve, reject) => {

            this.vehicleService.getVehicleTypes().then((res: any) => {


                if (res.status) {

                    res.data.forEach(vt => {
                        this.vehicleTypes.push(new VehicleType(vt));
                    });
                    var suggestions = this.getVehicleTypeSuggestionsForTrip();

                    suggestions.forEach(s => {
                        if (s != null) {
                            var v = new Vehicle({
                                vehicleid: null,
                                vehicletypeid: s.TypeRatio.type.id,
                                capacity: s.TypeRatio.type.capacity,
                                remainingSeats: s.TypeRatio.type.capacity,
                                driverid: -1,
                                contracted: 1,
                                driverfirstname: "CONTRACTOR",
                                driverlastname: "CONTRACTOR",
                                make: "CONTRACTED",
                                model: "CONTRACTED",
                                runtimeid: this.guid(),
                                year: 2000,
                                shifts: [],
                                available: true,
                                companyid: this.runConfig.companyid,
                                company_location_id: this.runConfig.companyLocationId,

                            });
                            s.vehicleReservation = new VehicleReservation(v);
                        }
                    })

                    resolve(suggestions);

                } else {
                    alert("Vehicle Suggestion: Could not get vehicle types (" + res.message + ")");
                    reject(res.message);
                }

            }).catch(e => {
                alert("Vehicle Suggestion: Could not get vehicle types: " + e);
                reject(e);
            });
        })
    }



    private getVehicleTypeSuggestionsForTrip(): Array<Suggestion> {

        var bestVehicleType = null;
        var suggestions = new Array<Suggestion>();

        this.trips.forEach(t => {

            var passengerCount = t.getTotalPassengers().length;
            var typeRatio = null;

            for (var i = 0; i < this.vehicleTypes.length; i++) {

                var type = this.vehicleTypes[i];
                var ratio = type.capacity / passengerCount;
                if (ratio >= 1) {
                    //Vehicle can hold
                    if (typeRatio == null) {
                        typeRatio = new TypeRatio(type, ratio);
                    } else if (ratio < typeRatio.ratio) {
                        typeRatio = new TypeRatio(type, ratio);
                    }
                }
            }
            suggestions.push(new Suggestion(t, typeRatio));
        });

        return suggestions;
    }

    guid() {

        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
}